import React from "react"
import { Link } from "gatsby"
// FontAwesomeのコンポーネントとアイコンをインポート
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faGift,
  faTools,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons"
import * as styles from "../../styles/featurehubcard.module.scss"

const FeatureHubCard = ({ area = "共通" }) => {
  // エリア名に合わせてタイトルとアイコンを切り替える
  const isGear = area === "ギア"
  const title = isGear ? "愛用ギア・装備まとめ" : `${area}のお土産まとめ`
  const icon = isGear ? faTools : faGift

  return (
    <Link to="/gearnsouvenir" className={styles.cardWrapper}>
      <div className={styles.content}>
        <div className={styles.iconArea}>
          <FontAwesomeIcon icon={icon} className={styles.mainIcon} />
        </div>
        <div className={styles.textArea}>
          <p className={styles.subTitle}>エリア別・アイテム図鑑</p>
          <h3 className={styles.title}>{title}</h3>
        </div>
      </div>
      <div className={styles.arrowArea}>
        <FontAwesomeIcon icon={faChevronRight} className={styles.arrowIcon} />
      </div>
    </Link>
  )
}

export default FeatureHubCard
